<app-page-header title="Soirées speed dating à Nantes" subtitle="Les prochains événements pour célibataires" [isWhiteBackground]="false" [bigSubtitle]="true"></app-page-header>

<div class="flex flex-col mt-70 xs-home:mt-80 2xs:mt-80 sm:mt-95 md:mt-90 md-home-2:mt-85 lg:mt-85 xl:mt-80 lg:-ml-18">
  <div class="w-full font-theme-source text-theme-black w-full ml-auto mr-auto lg:w-[1024px] 2xl:w-[90rem] 2xl:pt-10 pb-5 z-9994 relative">
    <div class="flex flex-col w-full relative">
      <div class="w-9/10 ml-5 2xs:ml-10 ">
        <p>Envie de sortir des applications et de rencontrer pour de vrai des célibataires nantais ? <span class="italic">7 minutes pour toi</span> organise des soirées de speed dating à Nantes pour partager plusieurs tête-à-tête de 7 minutes dans une ambiance conviviale, bienveillante et sans prise de tête.
        </p>
        <p>
          Une date, un lieu, une tranche d’âge… Choisis la soirée qui te ressemble et laisse une conversation, un sourire ou un feeling créer la surprise.
        </p>
      </div>
    </div>

  </div>
  <app-home-events class="">
    <div class="bg-white font-theme-source pt-10 pl-5 pr-5 2xl:pl-10 2xl:pr-10 mb-10">
      <h2 class="font-theme-source text-2xl 2xs:text-2xl lg:text-3xl text-theme-black font-bold pr-5">Pourquoi participer à une soirée speed dating à Nantes ?</h2>
      <p class="mt-10">
        Une soirée speed dating, ce n’est pas simplement une succession de rendez-vous chronométrés. C’est une occasion de quitter les écrans pour retrouver le plaisir d’un véritable échange en face à face. Pendant 7 minutes, tu
        peux découvrir une personnalité, partager quelques rires, briser la glace et ressentir si une belle connexion mérite un deuxième rendez-vous.
      </p>
      <p class="mt-5">
        Pas de faux profils ni de longues conversations virtuelles sans lendemain : les profils sont vérifiés et chaque participant vient avec la même envie de faire de nouvelles rencontres.
      </p>
      <p class="mt-5">
        Une animatrice locale t’accueille, t’explique le fonctionnement et reste présente tout au long de l’événement. Une attention particulière est également portée à l’équilibre des participants et à la compatibilité des tranches d’âge pour que chacun puisse
        vivre la soirée dans de bonnes conditions.
      </p>
      <p class="mt-5">
        Tu viens avant tout avec l’envie de faire une rencontre amoureuse et de découvrir des célibataires qui partagent la même démarche. Rien n’est écrit à l’avance : parfois, 7 minutes suffisent pour faire naître un coup de cœur, créer une belle connexion et donner envie de se retrouver
        lors d’un deuxième rendez-vous.
      </p>
      <h2 class="font-theme-source text-2xl 2xs:text-2xl lg:text-3xl text-theme-black font-bold pr-5 mt-15">Comment choisir la soirée célibataire qui te correspond ?</h2>
      <p class="mt-10">
        Chaque événement pour célibataires à Nantes précise les tranches d’âge concernées. Consulte-les avant ton inscription afin de sélectionner la soirée la plus adaptée à ton profil et aux personnes que tu souhaites rencontrer.
      </p>
      <p class="mt-5">
        Ton planning est ensuite préparé selon tes critères, afin de te proposer plusieurs rencontres avec des célibataires dont les préférences d’âge sont réciproquement compatibles. Tu peux également tenir compte de la date et du lieu pour choisir l’événement qui s’intègre le plus facilement à ton emploi du temps.
      </p>
      <p class="mt-5">
        Pas de stress si tu hésites entre plusieurs dates : toutes les informations utiles sont indiquées sur la présentation de chaque soirée avant la réservation.
      </p>
      <h2 class="font-theme-source text-2xl 2xs:text-2xl lg:text-3xl text-theme-black font-bold pr-5  mt-15">Notre sélection de lieux partenaires</h2>
      <p class="mt-10">
        Parce que le décor participe aussi à la magie d’une rencontre, nos établissements partenaires sont sélectionnés pour leur atmosphère, leur confort et leur style accueillant. L’objectif est de te proposer un lieu dans lequel tu peux rapidement te sentir à l’aise et échanger naturellement avec les autres participants.
      </p>
      <p class="mt-5">
        À Nantes, nos soirées peuvent notamment se dérouler à L’Atelier, aux Brassés ou au Wilton. L’établissement retenu est indiqué sur la présentation de chaque événement afin que tu puisses organiser sereinement ta venue.
      </p>


      <h2 class="font-theme-source text-2xl 2xs:text-2xl lg:text-3xl text-theme-black font-bold pr-5  mt-15">Questions fréquentes sur nos événements pour célibataires à Nantes</h2>

      <div class="w-full">
        <hr class="w-full lg:mt-10 md:mt-12 md:mb-8 my-8" />

        <div class="w-full md:px-6">
          <div class="mainHeading flex justify-between items-center w-full">
            <div class="">
              <h3 class="flex justify-center items-center  leading-6 md:leading-4 text-theme-black font-theme-source ">
                <span class="lg:mr-6 mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">Où et quand ont lieu les prochaines soirées speed dating à Nantes ?</span></h3>
            </div>
            <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
              <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
            </button>
          </div>
          <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
            <p class="pb-2">Les dates, les horaires et les établissements sont indiqués dans les cartes des événements. De nouvelles soirées peuvent être ajoutées au calendrier : n’hésite pas à consulter régulièrement cette page pour découvrir les prochains rendez-vous nantais.
            </p>
          </div>
        </div>

        <hr class="w-full lg:mt-10 my-8" />

        <div class="w-full md:px-6">
          <div class="mainHeading flex justify-between items-center w-full">
            <div class="">
              <h3 class="flex justify-center items-center  leading-6 md:leading-4 text-theme-black font-theme-source ">
                <span class="lg:mr-6 mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">Quelles tranches d’âge sont proposées ?</span></h3>
            </div>
            <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
              <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
            </button>
          </div>
          <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
            <p class="pb-2">
              Les tranches d’âge varient selon les soirées. Elles sont précisées pour chaque événement afin que tu puisses facilement identifier celui qui correspond à ton profil. Le planning de rencontres est ensuite préparé en tenant compte des préférences d’âge réciproques des participants.
            </p>
          </div>
        </div>

        <hr class="w-full lg:mt-10 my-8" />


        <div class="w-full md:px-6">
          <div class="mainHeading flex justify-between items-center w-full">
            <div class="">
              <h3 class="flex justify-center items-center  leading-6 md:leading-4 text-theme-black font-theme-source ">
                <span class="lg:mr-6 mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">Peut-on venir seul à une soirée célibataire ?</span></h3>
            </div>
            <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
              <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
            </button>
          </div>
          <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
            <p class="pb-2">
              Bien sûr ! Tu peux participer seul(e) à une soirée. Dès ton arrivée, l’animatrice t’accueille et t’explique le déroulement de l’événement. Les tête-à-tête permettent ensuite de faire naturellement connaissance, sans avoir à chercher comment aborder les autres participants.
            </p>
          </div>
        </div>

        <hr class="w-full lg:mt-10 my-8" />

        <div class="w-full md:px-6">
          <div class="mainHeading flex justify-between items-center w-full">
            <div class="">
              <h3 class="flex justify-center items-center  leading-6 md:leading-4 text-theme-black font-theme-source ">
                <span class="lg:mr-6 mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">Quel est le tarif d’une soirée et que comprend l’inscription ?</span></h3>
            </div>
            <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
              <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
            </button>
          </div>
          <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
            <p class="pb-2">
              Le tarif est indiqué sur la page de présentation de chaque événement avant la validation de ton inscription. Les premières formules sont actuellement proposées à partir de 10,90 €, ce montant pouvant varier selon la formule sélectionnée.
            </p>
          </div>
        </div>

        <hr class="w-full lg:mt-10 my-8" />

        <div class="w-full md:px-6">
          <div class="mainHeading flex justify-between items-center w-full">
            <div class="">
              <h3 class="flex justify-center items-center  leading-6 md:leading-4 text-theme-black font-theme-source ">
                <span class="lg:mr-6 mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">Quel est le tarif d’une soirée et que comprend l’inscription ?</span></h3>
            </div>
            <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
              <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
            </button>
          </div>
          <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
            <p class="pb-2">
              Le tarif est indiqué sur la page de présentation de chaque événement avant la validation de ton inscription. Les premières formules sont actuellement proposées à partir de 10,90 €, ce montant pouvant varier selon la formule sélectionnée.
            </p>
            <p class="pb-2">
              L’inscription comprend ta participation aux rencontres planifiées ainsi que la réception de tes coups de cœur réciproques après la soirée. Des options complémentaires peuvent également être proposées pour personnaliser ton expérience.
            </p>
          </div>
        </div>

        <hr class="w-full lg:mt-10 my-8" />

        <div class="w-full md:px-6">
          <div class="mainHeading flex justify-between items-center w-full">
            <div class="">
              <h3 class="flex justify-center items-center  leading-6 md:leading-4 text-theme-black font-theme-source ">
                <span class="lg:mr-6 mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">Comment réserver sa place pour une soirée speed dating à Nantes ?</span></h3>
            </div>
            <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
              <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
            </button>
          </div>
          <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
            <p class="pb-2">
              Choisis l’événement qui t’intéresse, consulte les informations pratiques puis complète ton inscription en ligne. Un e-mail de confirmation te sera envoyé une fois celle-ci enregistrée. Tu recevras ensuite les informations nécessaires avant la date de la soirée.
            </p>
          </div>
        </div>

        <hr class="w-full lg:mt-10 my-8" />

      </div>
    </div>
  </app-home-events>
  <div class="flex flex-col w-full bg-white">
    <app-page-footer></app-page-footer>
  </div>
</div>

